// Money in paise shown as rupees: "₹1,840" or "₹320.50" (integer arithmetic only).
const GROUPING = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 });

export function formatPaise(paise: number): string {
  const rupees = Math.floor(Math.abs(paise) / 100);
  const rest = Math.abs(paise) % 100;
  const text =
    rest === 0
      ? `₹${GROUPING.format(rupees)}`
      : `₹${GROUPING.format(rupees)}.${String(rest).padStart(2, "0")}`;
  return paise < 0 ? `-${text}` : text;
}

const KIND: Record<string, string> = {
  TEXTBOOK: "Textbook",
  WORKBOOK: "Workbook",
  NOTEBOOK: "Notebook",
  STATIONERY: "Stationery",
  UNIFORM: "Uniform",
  OTHER: "Item",
};
export const kindLabel = (kind: string) => KIND[kind] ?? "Item";

const SUBJECT: Record<string, string> = {
  ENGLISH: "English",
  MATHEMATICS: "Mathematics",
  SCIENCE: "Science",
  SOCIAL_STUDIES: "Social Studies",
  ENVIRONMENTAL_STUDIES: "EVS",
  HINDI: "Hindi",
  TELUGU: "Telugu",
  SANSKRIT: "Sanskrit",
  OTHER_LANGUAGE: "Languages",
  COMPUTER_SCIENCE: "Computer Science",
  GENERAL_KNOWLEDGE: "General Knowledge",
  MORAL_SCIENCE: "Moral Science",
  ART_AND_CRAFT: "Art and Craft",
  OTHER: "Other",
};
export const subjectLabel = (subject: string | null | undefined) =>
  subject ? (SUBJECT[subject] ?? subject) : "Other";
